import { GradeConversionCreateLayout } from './layouts';

export function GradeConversionCreatePage() {
  return <GradeConversionCreateLayout />;
}
